import { v4 as uuid } from "uuid";

/**
 * Category Database can be added here.
 * You can add category of your wish with different attributes
 * */

export const categories = [
  {
    _id: uuid(),
    src: "ytc/AKedOLQ-IPFEzpiA0AqSSeK7ZiBWUfrG4a3OZar2p3tXNQ",
    categoryName: "Zakir Khan",
  },
  {
    _id: uuid(),
    src: "ytc/AKedOLQFBbx9iNh-JQvEo61AHkcDrkbY-Pavaba-y2ck9w",
    categoryName: "Abhishek Upmanyu",
  },
  {
    _id: uuid(),
    src: "ytc/AKedOLT4Em51isWMSdGWnXAjOQr-D2WRCnnbGQbRXjyj1JU",
    categoryName: "Munawar Faruqui",
  },
  {
    _id: uuid(),
    src: "tQRnHeVFIYQ7DTAcGpQHXwEZeq7u7b3geX_MQ3ON0QcXq8nCL6_WJiwnkPYWRzBwrljscCIMFA",
    categoryName: "Haseeb Khan",
  },
  {
    _id: uuid(),
    src: "ytc/AKedOLSvPEUzOL_qQkQQd17lcsvj3ikeb2iEj92MUBi91A",
    categoryName: "Aakash Gupta",
  },
  {
    _id: uuid(),
    src: "ytc/AKedOLTuDOpO2Vc50eR-mu8HjPzDXwnZkqUW_ZDCoQQGCg",
    categoryName: "Harsh Gujral",
  },
];
